import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';

// todo lw fix typo

@Injectable()
export class NavService {

    constructor(private _router: Router, private location: Location) {}

    public goToPage(pageId: any = '/', params?: Object, queryParams?: Object, state?: any): Promise<boolean> {
        const navigationExtras: NavigationExtras = {};
        
        if (queryParams) {
            navigationExtras.queryParams = queryParams;
        }
        
        if (state) {
            navigationExtras.state = state;
        }
        
        return this._router.navigate(params ? [pageId, params] : [pageId], navigationExtras);
    }

    public navigateBack() {
        this.location.back();
    }

    get router(): Router {
        return this._router;
    }
}
